/**
 * Shared loading + error states for the RD bucket pages so the bucket
 * components stay focused on layout.
 */
import { AlertTriangle } from 'lucide-react';
import type { ReactNode } from 'react';

export function BucketLoading() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 240,
        color: 'var(--nb-subtle)',
        fontSize: 13,
      }}
    >
      <div
        style={{
          width: 24,
          height: 24,
          borderRadius: '50%',
          border: '2px solid var(--nb-primary)',
          borderTopColor: 'transparent',
          animation: 'spin 1s linear infinite',
          marginRight: 8,
        }}
      />
      Loading…
      <style>{`@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}

export function BucketError({ error }: { error: unknown }) {
  const msg = error instanceof Error ? error.message : 'Failed to load data';
  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '16px 20px',
        borderRadius: 'var(--nb-radius-card)',
        background: 'var(--nb-warn-soft)',
        color: 'var(--nb-warn)',
        fontSize: 13,
      }}
    >
      <AlertTriangle size={16} />
      <span>{msg}</span>
    </div>
  );
}

export function SectionCard({
  title,
  action,
  children,
}: {
  title?: string;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="nb-card" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {(title || action) && (
        <header className="nb-card-hd">
          {title && <h3>{title}</h3>}
          {action}
        </header>
      )}
      {children}
    </section>
  );
}
